import { render, staticRenderFns } from "./ManageProjectForum.vue?vue&type=template&id=4a823275&"
import script from "./ManageProjectForum.vue?vue&type=script&lang=js&"
export * from "./ManageProjectForum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports